<template>
  <div class="layout" style="height: 100%">
    <!-- 头部内容 -->
    <Header class="nav">
      <Menu mode="horizontal" theme="primary" active-name="1">
        <div class="layout-logo">掌大师</div>
        <div class="layout-nav">
          <MenuItem name="1">
            <span @click="bossIndex()" v-if="isWho==1">
              <Icon type="md-home" size="20" />BOSS首页
            </span>
            <span @click="$router.push('/content')" v-else>
              <Icon type="md-home" size="20" />首页
            </span>
          </MenuItem>
          <MenuItem name="2">
            <span @click="playVideo">
              <Icon type="md-videocam" size="20" />新手教学
            </span>
          </MenuItem>
          <MenuItem name="3">
            <a
              href="http://m.test.tangyingchina.cn/col.jsp?id=119"
              style="color:#fff;"
              target="_blank"
            >
              <Icon type="ios-help-circle-outline" size="20" />帮助中心
            </a>
          </MenuItem>
          <MenuItem name="4">
            <!---->
            <Dropdown>
              <span href="javascript:void(0)">
                <Avatar :src="imgdata" />
                {{adminData.name}}
                <Icon type="ios-arrow-down"></Icon>
              </span>
              <DropdownMenu slot="list">
                <DropdownItem>
                  <span @click="personal">个人中心</span>
                </DropdownItem>
                <DropdownItem>
                  <span @click="exitSystem()">退出系统</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </MenuItem>
        </div>
      </Menu>
    </Header>
    <div class="video_box" v-if="!isCloseVideo">
      <!-- <Icon type="md-close-circle" class="close_icon" size="100" @click="isCloseVideo=true" /> -->
      <img src="./../assets/img/close.png" class="close_icon" v-if="isVideo" @click="closeVideo" />
      <p class="video_txt">掌大师轻松上手</p>
      <video
        id="video"
        src="https://tangyingkeji.oss-cn-beijing.aliyuncs.com/static/zdsvideo.mp4"
        controls="controls"
        autoplay="autoplay"
      >您的浏览器不支持 video 标签。请升级后重试</video>
    </div>
    <!--导航+主体内容-->
    <router-view />
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      isWho: JSON.parse(localStorage.getItem("adminUser")).type,
      adminData: {},
      imgdata: "",
      isVideo: false,
      isCloseVideo: true,
      videoDom: null,
      isVideoPlay: false
    };
  },
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  mounted: function() {
    /*this.$Api.getGoordsCountBycid({ cid: this.adminData.cid }).then(res => {
      if (res.data.status == "1" && this.$route.fullPath == "/main") {
        this.isCloseVideo = false;
        this.$nextTick(function() {
          this.videoDom = document.getElementById("video");
        });
        this.$Message.warning({
          content: '新增商品后将不再自动弹出此视频',
          duration: 0,
          closable: true
        });
      } else {
        this.isCloseVideo = true;
      }
    });*/
  },
  created: function() {
    //DOM更新完之前请求数据
    //获取用户信息
    this.adminData = JSON.parse(localStorage.getItem("adminUser"));
    let name = this.$route.name
    
    this.$Api
      .getCompanyId({
        id: this.adminData.cid
      })
      .then(res => {
        if (res.code == 200) {
          console.log(res.data.imgurl)
          if(res.data.imgurl){
            this.imgdata =
                    "https://tangyingkeji.oss-cn-beijing.aliyuncs.com/tangyingkeji.oss-cn-beijing.aliyuncs.com" +
                    res.data.imgurl;
          }else {
            this.imgdata= require('../assets/img/logo.png')
          }

        } else {
          this.$Message.warning(res.msg);
        }
      });
  },
  methods: {
    goPages() {
      this.$router.push({ path: "/PurchasingBill" });
    },
    bossIndex() {
      localStorage.removeItem("shop");
      localStorage.removeItem("registerShop");
      this.$router.push({ path: "/main" });
    },
    //退出系统
    exitSystem() {
      var isRemember = localStorage.getItem("isRemember");
      var rememberTel = localStorage.getItem("rememberTel");
      var rememberPass = localStorage.getItem("rememberPass");
      localStorage.clear();
      localStorage.setItem("isRemember", isRemember);
      localStorage.setItem("rememberTel", rememberTel);
      localStorage.setItem("rememberPass", rememberPass);
      this.$router.push("/login");
    },
    personal() {
      if (
        localStorage.getItem("shop") == null &&
        JSON.parse(localStorage.getItem("adminUser")).type == 1
      ) {
        this.$Message.info("先进入你的店铺");
        return;
      }
      this.$router.push("/my");
    },
    closeVideo() {
      this.videoDom = document.getElementById("video");
      this.videoDom.pause();
      this.isCloseVideo = true;
      this.isVideo = false;
    },
    playVideo() {
      this.isCloseVideo = false;
      this.$nextTick(() => {
        this.videoDom = document.getElementById("video");
        this.videoDom.play();
        this.isVideo = true;
      });
    }
  },
  watch: {
    // videoDom: {
    //   handler(val) {
    //     var that = this;
    //     if (val) {
    //       //监听播放时间
    //       //使用事件监听方式捕捉事件
    //       val.addEventListener("timeupdate", function() {
    //         var timeDisplay;
    //         //用秒数来显示当前播放进度
    //         timeDisplay = Math.floor(val.currentTime);
    //         //当视频播放到 4s的时候做处理
    //         if (timeDisplay >= 10) {
    //           //处理代码
    //           if (that.isVideo == false) {
    //             that.isVideo = true;
    //           }
    //         }
    //       });
    //     } else {
    //       that.isVideo = false;
    //     }
    //   },
    //   deep: true
    // }
  }
};
</script>


<style scoped>
.video_box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.4);
}
.video_box video {
  width: 100%;
  height: 100%;
}
.video_txt {
  position: absolute;
  top: 20px;
  width: 100%;
  line-height: 20px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  letter-spacing: 10px;
}
.close_icon {
  position: absolute;
  width: 48px;
  height: 48px;
  top: 40px;
  right: 40px;
  z-index: 9999;
}
.video_box.hidden {
  display: none;
}

.nav {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-logo {
  width: 200px;
  height: 30px;
  float: left;
  position: relative;
  top: 0px;
  left: 20px;
  font-size: 28px;
  color: #fefeff;
  font-family: AdobeHeitiStd-Regular;
}
.layout-nav {
  margin: 0 auto;
  margin-right: 20px;
  float: right;
}
#create-outline {
  border-left: rgba(255, 255, 255, 0.2) 1px solid;
  border-right: rgba(255, 255, 255, 0.2) 1px solid;
}
.layout {
  border: 0;
  border-radius: 0;
}
.ivu-layout-header {
  background: #2d8cf0;
  padding: 0;
  padding-right: 50px;
  height: 70px;
}
.ivu-menu-horizontal {
  height: 70px;
  line-height: 70px;
}
.ivu-menu-item {
  padding: 0 16px;
}
.icon-msg {
  font-size: 20px;
}
</style>